import type { PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import { PsHttpService } from '@patsnap/tahiti-core';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type {
    DocumentParseApi,
    DocumentParseRequest,
    DocumentParseResponse,
    SmartDocumentParseRequest,
    SmartDocumentParseResponse,
} from '../document-parse-api';
import {
    DOCUMENT_PARSE_API_PATHS,
    DEFAULT_FOLDER_PATH,
    DEFAULT_FILE_PREFIX,
} from '../../constants';
import { coreTelecomApiUrlPrefix } from '@telecom/shared/domain-config';

@injectable()
export class DocumentParseApiImpl extends PsHttpService implements DocumentParseApi {
    get options() {
        return {
            baseURL: coreTelecomApiUrlPrefix,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }

    async parseDocument(request: DocumentParseRequest): Promise<DocumentParseResponse> {
        const formData = new FormData();
        formData.append('file', request.file);
        formData.append('parse_type', request.parse_type);
        formData.append('folder_path', request.folder_path ?? DEFAULT_FOLDER_PATH);
        formData.append('file_prefix', request.file_prefix ?? DEFAULT_FILE_PREFIX);
        formData.append(
            'generate_unique_name',
            String(request.generate_unique_name ?? true),
        );

        const result = await this.post<PatSnapSuccessResponseData<DocumentParseResponse>>({
            url: DOCUMENT_PARSE_API_PATHS.PARSE,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return result.data;
    }

    async smartParseDocument(request: SmartDocumentParseRequest): Promise<SmartDocumentParseResponse> {
        const formData = new FormData();
        formData.append('file', request.file);

        const result = await this.post<PatSnapSuccessResponseData<SmartDocumentParseResponse>>({
            url: DOCUMENT_PARSE_API_PATHS.SMART_PARSE,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return result.data;
    }
}
